const MODAL_QUERY_VALUE = 'dealer-enquiry';
const MODAL_QUERY_KEY = 'modal';
/**
 * This query is used to open the dealer enquiry modal
 */
const MODAL_QUERY = { [MODAL_QUERY_KEY]: MODAL_QUERY_VALUE };

export { MODAL_QUERY_KEY, MODAL_QUERY_VALUE, MODAL_QUERY };
